import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, get, filter } from 'lodash';
import { history } from 'routers';
import { View, Image } from '@zhike/ti-ui';
import { Modal } from '@zhike/ti-component';
import { createPromise, redirectToLoginPage, getToken } from 'utils/action';
import HeaderContainer from 'containers/header';
import Header from 'components/header';
import ChooseOneQuestion from 'components/questions/choose_one';
import ChooseManyQuestion from 'components/questions/choose_many';
import BlankQuestion from 'components/questions/blank';
import SpeakingQuestion from 'components/questions/speaking';
import WritingQuestion from 'components/questions/writing';
import FollowUpQuestion from 'components/questions/follow_up';
import SelectQuestion from 'components/questions/select';
import SortQuestion from 'components/questions/sort';
import Welcome from 'components/testPages/welcome';
import ListeningTest from 'components/testPages/listening_test';
import SpeakingTest from 'components/testPages/speaking_test';
import Resting from 'components/testPages/resting';
import End from 'components/end';
import styles from './styles';


// 做题
export default class Exercise extends Component {
  // 参数
  static propTypes = {
    practice: PropTypes.object.isRequired,
    stepList: PropTypes.object.isRequired,
    record: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setRecord: PropTypes.func.isRequired,
    getUploadSignature: PropTypes.func.isRequired,
    postMachinePigai: PropTypes.func.isRequired,
    postAnswer: PropTypes.func.isRequired,
  };

  // 即将加载
  componentWillMount() {
    const { practice, stepList, match } = this.props;
    const { mode, practiceId } = match.params;
    // TODO 需要复原完整的访问路径
    if (
      get(practice, 'status') !== 'SUCCESS' ||
      get(stepList, 'status') !== 'SUCCESS'
    ) {
      global.location.href = `/init/${mode}/${practiceId}`;
    }
  }

  // 加载
  componentDidMount() {
    this.updateVisitedMark();
    this.testTip(this.props)
  }

  // 更新
  componentWillUpdate() {
    this.updateVisitedMark();
  }

  /**
   * 测评登录后置的提示
   */
  testTip(props) {
    const { mode, stepId } = props.match.params;
    if (mode === 'test' && stepId === '1' && !getToken()) {
      Modal.show('ModalAlert', {
        title: '温馨提示',
        buttons: [{
          title: '稍后再说',
          class: 'gray',
        },
        {
          title: '立即登录',
          onClick: () => redirectToLoginPage(),
        },
        ],
        width: 400,
        component: (
          <View className={styles.modalAlert}>
            <Image
              className={styles.modalAlertImage}
              src={require('components/assets/default.png')}
              style={{ width: '80px', margin: '20px 0 28px' }}
            />
            <View className={styles.modalAlertText}>
              你尚未登录，登录后系统才能生成测评报告哦~
            </View>
          </View>
        ),
      }, () => { Header.pauseTimer(); }, () => { Header.startTimer(); });
    }
  }

  // 获取答案
  getAnswer(step, value) {
    const answer = {
      questionId: step.question.id,
      answerType: step.question.type,
    };

    const questionMaterialId = step.question.materials &&
      step.question.materials[0] && step.question.materials[0].id || null;
    answer.userAnswers = [{
      questionMaterialId,
      userAnswer: value,
    }];

    return answer;
  }

  // 设置做题记录
  async setRecord(keys, value) {
    const { setRecord } = this.props;
    const { mode, exerciseId } = this.props.match.params;

    await setRecord({
      mode,
      id: exerciseId,
      keys,
      value,
    });
  }

  // 设置当前步骤的做题记录
  async setStepRecord(step, key, value, isLast = false) {
    try {
      await this.setRecord(['step', step.id, key], value);
      if (key === 'answer') {
        const { postAnswer, postMachinePigai } = this.props;
        const { exerciseId, mode } = this.props.match.params;
        const answer = await createPromise(postAnswer, {
          exerciseId: parseInt(exerciseId, 10),
          practiceId: step.practice.id,
          duration: parseInt(Header.getTime() / 1000, 10),
          subjectId: step.practice.subjectId,
          answers: [this.getAnswer(step, value)],
          time: new Date().getTime(),
        });
        // 点击next 提交机器批改
        if (mode === 'test' && isLast && step.questionType === 'Writing' && value) {
          await createPromise(postMachinePigai, {
            subject: 'writing',
            answerId: answer.data.records[0].answerId,
          });
        }
        if (mode === 'test' && isLast && step.questionType === 'Speaking' && value && value.src) {
          await createPromise(postMachinePigai, {
            subject: 'speaking',
            answerId: answer.data.records[0].answerId,
          });
        }

        return answer;
      }
    } catch (e) {
      console.log(e);
      setTimeout(() => {
        history.push(`/error/save/${encodeURIComponent(global.location.href)}`);
      }, 100);
    }
  }

  // 更新访问标记
  updateVisitedMark() {
    const { record } = this.props;
    const { stepId } = this.props.match.params;
    const stepRecord = record.step && record.step[stepId] ? record.step[stepId] : {};

    if (!stepRecord.isVisited) {
      this.setRecord(['step', stepId, 'isVisited'], true);
    }

    // 滚动到顶部
    if (this.pathName !== global.location.pathname) {
      if (this.anchor) {
        setTimeout(() => {
          this.anchor && this.anchor.scrollIntoView({
            behavior: 'smooth',
          });
        }, 50);
        this.pathName = global.location.pathname;
      }
    }
  }

  // 渲染
  render() {
    const { practice, stepList, record, getUploadSignature, postMachinePigai } = this.props;
    const { stepId, operation, mode } = this.props.match.params;
    const step = cloneDeep(stepList.data[stepId - 1]);
    const { practicePackage, questions } = practice.data.questionBackup;
    if (mode === 'test') {
      const { practices } = practice.data.questionBackup;
      step.practice = Array.isArray(practices) &&
        filter(practices, { id: step.practiceId })[0] || practices[0];
      step.practice.name = practicePackage.name; // 用套题的name 覆盖每个练习的name
      step.question = Array.isArray(questions) &&
        filter(questions, { id: step.questionId })[0];
    } else {
      step.practice = practice.data.questionBackup;
      step.question = questions[step.id - 1];
    }
    // 生成参数信息
    const renderProps = {
      params: this.props.match.params,
      stepList: stepList.data,
      step,
      record,
      stepRecord: record.step && record.step[step.id] ? record.step[step.id] : {},
      setRecord: async (keys, value) => { await this.setRecord(keys, value); },
      setStepRecord: async (key, value, isLast = false) => await this.setStepRecord(step, key, value, isLast), // eslint-disable-line
      getUploadSignature,
      postMachinePigai,
      question: step.question,
    };
    // 生成组件信息
    let RenderComponent;
    switch (step.questionType) {
      case 'Welcome':
        RenderComponent = Welcome;
        break;
      case 'ListeningTest':
        RenderComponent = ListeningTest;
        break;
      case 'SpeakingTest':
        RenderComponent = SpeakingTest;
        break;
      case 'Resting':
        RenderComponent = Resting;
        break;
      case 'ChooseOne':
        RenderComponent = ChooseOneQuestion;
        break;
      case 'ChooseMany':
        RenderComponent = ChooseManyQuestion;
        break;
      case 'Blank':
      case 'SubjectBlank':
        RenderComponent = BlankQuestion;
        break;
      case 'Speaking':
        RenderComponent = SpeakingQuestion;
        break;
      case 'Writing':
        RenderComponent = WritingQuestion;
        break;
      case 'FollowUp':
        RenderComponent = FollowUpQuestion;
        break;
      case 'PointSelect':
      case 'SortPointSelect':
        RenderComponent = SelectQuestion;
        break;
      case 'Sort':
        RenderComponent = SortQuestion;
        break;
      case 'End':
        RenderComponent = End;
        break;
      default:
        break;
    }
    // 渲染
    return (
      <View className={styles.container}>
        <HeaderContainer {...renderProps} />
        <View className={styles.children}>
          <div ref={anchor => { this.anchor = anchor; }} />
          {
            !operation && RenderComponent &&
            <RenderComponent {...renderProps} />
          }
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/exercise/index.js